module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/view/clients/clients-grid/clients-grid.component.css
// module id = ./src/app/pages/view/clients/clients-grid/clients-grid.component.css
// module chunks = main